import Barcode from 'react-barcode';

interface Props {
	value: string;
}

/**
 * AG Grid 셀에서 바코드를 렌더링하는 컴포넌트
 */
export const BarcodeRenderer = (props: Props) => {
	const { value } = props;

	if (!value) return null;

	return (
		<div className="flex items-center justify-center h-full">
			<Barcode 
				value={value}
				format="CODE39"
				width={1}
				height={30}
				fontSize={10}
				margin={0}
				displayValue={true}
			/>
		</div>
	);
};

/**
 * AG Grid cellRenderer로 사용할 함수
 */
export const barcodeCellRenderer = (params: any) => {
	// 하단 고정 행(합계 행)은 바코드 렌더링 안 함
	if (params.node.rowPinned) return '';
	
	if (!params.data?.barcode) return '';
	
	return <BarcodeRenderer value={params.data.barcode} />;
};

